import CONFIG from "Config";
import { getUnlayerTheme } from "helpers/unlayerTheme";

/**
 * Shared Unlayer `options` common to every graphical email editor mount.
 *
 * Keeping this in one place makes the design-tag delimiter a single source of
 * truth — a new editor that spreads this can't silently drift back to
 * Unlayer's `[[ ]]` default. Callers spread the result and add their own
 * per-editor keys (e.g. `mergeTags`, `specialLinks`).
 */
export function buildUnlayerOptions() {
  return {
    projectId: CONFIG.UNLAYER_PROJECT_ID,
    features: { audit: true },
    // Vector tracking tags use [[ ]]; move Unlayer's design-tag delimiter off
    // [[ ]] to (( )) so those tags pass through to the exported HTML verbatim.
    designTagsConfig: { delimiter: ["((", "))"] },
    fonts: {
      showDefaultFonts: true,
      customFonts: [
        { label: "MS Mincho", value: "'MS Mincho','ＭＳ 明朝'" },
        { label: "MS Gothic", value: "'MS Gothic', 'ＭＳ ゴシック'" },
        { label: "MS PGothic", value: "'MS PGothic', 'ＭＳ Ｐゴシック'" },
      ],
    },
    appearance: {
      theme: getUnlayerTheme(),
    },
  };
}
